import api from "./axios"; // adapte si ton projet utilise axios instance ailleurs

export async function fetchEligibleLabs(packId) {
  const params = {};
  if (packId) params.pack_id = packId;
  const res = await api.get("/labs/eligible", { params });
  return res.data; // { wallets:[], items:[] }
}
